import Cookies from 'universal-cookie';

const DEFAULT_LANGUAGE = 'ko';

export const getCookie = key => {
  const cookieStr = document.cookie.replace(/ /gi, '');
  const cookieSplit = cookieStr.split(';');
  const cookieObj = {};
  try {
    for (let i = 0; i < cookieSplit.length; i++) {
      const nameSeq = cookieSplit[i].indexOf('=');
      const cookieKey = cookieSplit[i].substring(0, nameSeq);
      let cookieVal = cookieSplit[i].substring(nameSeq + 1);
      cookieVal = cookieVal.replace(/"/gi, '');
      cookieObj[cookieKey] = cookieVal;
    }
  } catch (e) {
    // console.log(e);
  }
  return cookieObj[key] || '';
};

export const getLanguage = () => {
  let language = DEFAULT_LANGUAGE;
  const saveLanguage = getCookie('saveLanguage');
  if (saveLanguage && saveLanguage.length >= 2) {
    if (saveLanguage.includes('zh_TW')) {
      language = saveLanguage.substring(3, 5).toLowerCase();
    } else language = saveLanguage.substring(0, 2);
  }
  return language;
};

const getIsCookieSave = cookieSavedYN => {
  return cookieSavedYN === 'Y';
};

const cookies = new Cookies();
export const setCookie = (cookieSavedYN, key, value, option) => {
  if (getIsCookieSave(cookieSavedYN)) {
    cookies.set(key, value, { ...option });
  }
};

export function getLocalStorage(cookieSavedYN, key) {
  if (getIsCookieSave(cookieSavedYN)) {
    return localStorage.getItem(`${key}`);
  }
  return null;
}

export function setLocalStorage(cookieSavedYN, key, val) {
  if (getIsCookieSave(cookieSavedYN)) {
    localStorage.setItem(`${key}`, val);
  }
}

export default {
  getCookie,
  setCookie,
  getLanguage,
  getLocalStorage,
  setLocalStorage,
};
